module.exports = __webpack_public_path__ + "img/GAME_BUTTERFLY2.c1e2395c.jpg";